export default "__VITE_ASSET__BInROvq3__"